import { Injectable } from '@angular/core';
import { ICardItem } from '@core/interfaces/card/card-item-interface';
import { ICardSource } from '@core/interfaces/card/card-source.interface';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { environment } from '@env';
import { HttpService } from '@interticket/core';
import { Observable } from 'rxjs';
import { CardCartItem } from '../../models/card/card-cart-item.model';

@Injectable()
export class CardSourceService implements ICardSource {

  private readonly serviceVersion: string = environment.modules.core.card.version;
  private readonly serviceBaseUrl: string = `/${this.serviceVersion}/card`;

  constructor(
    private httpService: HttpService
  ) { }

  getList(): Observable<IListResult<ICardItem>> {
    return this.httpService.get<IListResult<ICardItem>>(`${this.serviceBaseUrl}/cards`);
  }

  addToCart(item: CardCartItem): Observable<Response> {
    return this.httpService.put<Response>(`${this.serviceBaseUrl}/cart`, item);
  }

}
